import { useTranslation } from 'react-i18next';

import { IconActivity, IconHeart, IconReport } from '@tabler/icons-react';

import { Link, createFileRoute } from '@tanstack/react-router';

import {
  Anchor,
  Container,
  SimpleGrid,
  StandardLayoutView,
  SurfaceView,
  Text,
  Title,
} from '@optiro/ui';

import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const Route = createFileRoute('/app/reports/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userData } = useAuth();
  const { t } = useTranslation('reports');

  const canView = userData?.admin || userData?.role === 'administrator';
  if (!canView) return <Text>{t('not_authorized')}</Text>;

  return (
    <StandardLayoutView title={t('landing_title')}>
      <Container size="xl" py="xl">
        <SimpleGrid cols={3} spacing="md">
          <Anchor component={Link} to="/app/reports/trackers" underline="never">
            <SurfaceView padding="md">
              <IconActivity stroke={1.5} size={24} />
              <Title order={3} mt="xs">
                {t('trackers.card_title')}
              </Title>
              <Text size="sm" c="dimmed">
                {t('trackers.card_description')}
              </Text>
            </SurfaceView>
          </Anchor>
          <Anchor component={Link} to="/app/reports/feedback" underline="never">
            <SurfaceView padding="md">
              <IconHeart stroke={1.5} size={24} />
              <Title order={3} mt="xs">
                {t('feedback.card_title')}
              </Title>
              <Text size="sm" c="dimmed">
                {t('feedback.card_description')}
              </Text>
            </SurfaceView>
          </Anchor>
          <Anchor component={Link} to="/app/timesheets" underline="never">
            <SurfaceView padding="md">
              <IconReport stroke={1.5} size={24} />
              <Title order={3} mt="xs">
                {t('tidsforbrug.card_title')}
              </Title>
              <Text size="sm" c="dimmed">
                {t('tidsforbrug.card_description')}
              </Text>
            </SurfaceView>
          </Anchor>
        </SimpleGrid>
      </Container>
    </StandardLayoutView>
  );
}
